
import { useSelector } from 'react-redux';

export default function useAuthIsAccountActivated() {
    const activated = useSelector(state => {
        return (
            state.auth.data  &&
            state.auth.data.user &&
            state.auth.data.user.activated === 1
        );
    });
    return activated;
}
